import { useDispatch, useSelector } from "react-redux";
import { setLogs } from "../../Reducer/RevenueModuleSlice";
import { IoClose } from "react-icons/io5";

const fields = {
    plannedRevenue: 'Плановая выручка',
    revenueTotal: 'Выручка фактическая общая',
    revenueYE: 'Выручка ЯЕ/ДК',
    revenueKuper: 'Выручка Купер',
    revenueOnline: 'Выручка ЮКасса',
    revenueCash: 'Наличные в кассе',
    revenueNoncash: 'Безналичные',
    cashierFIO: 'Кассир (ФИО)',
}

export default function LogsModal() {
    const logs = useSelector((state) => state.RevenueModuleSlice.logs);

    const dispatch = useDispatch();

    const renderLog = (log) => {
        const { datetime, field, fio, prevValue, value } = log;

        let stringLog = null;

        if (prevValue) {
            if (value) {
                stringLog = `изменил данные в поле ${fields[field]} c ${prevValue} на ${value}`;
            } else {
                stringLog = `удалил данные в поле ${fields[field]}`;
            }
        } else {
            stringLog = `внес данные в поле ${fields[field]} ${value}`;
        }

        return `${datetime} Пользователь ${fio} ${stringLog}`
    }

    const onClose = () => {dispatch(setLogs(null))}
    
    return(
        <div className="ModalGlobalDiv" onClick={onClose}>
            <div className="ModalStaffManagmentMainDiv" onClick={(e) => e.stopPropagation()} style={{  overflowY: 'scroll', alignItems: 'start', justifyContent: 'start' }}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'end', padding: '0px 10px'}}>
                        <button className="CloseModalIconDiv" onClick={onClose} >
                            <IoClose className="CloseModalIcon" />
                        </button>
                </div>
                {logs.map((log) => (
                    <div>{renderLog(log)}</div>
                ))}
            </div>
        </div>
    )
}